<nav class="nav nav-pills">
  @if (showValidateReferral) {
    <a
      class="nav-item nav-link"
      href="#"
      (click)="navClick($event, 'validateReferral')"
      [class.active]="currentSection === 'validateReferral'">
      Validate Referral
    </a>
  }
  @if (showCeReviewDetails) {
    <a
      class="nav-item nav-link"
      href="#"
      (click)="navClick($event, 'ceReviewDetails')"
      [class.active]="currentSection === 'ceReviewDetails'">
      CE Review Details
    </a>
  }
  <a
    class="nav-item nav-link"
    href="#"
    (click)="navClick($event, 'patientPrescriptions')"
    [class.active]="currentSection === 'patientPrescriptions'">
    Patient Prescriptions
  </a>
  @if (showPatientDocuments) {
    <a
      class="nav-item nav-link"
      href="#"
      (click)="navClick($event, 'patientDocuments')"
      [class.active]="currentSection === 'patientDocuments'">
      Patient Documents
    </a>
  }
  @if (showConsultNoteVerification) {
    <a
      class="nav-item nav-link"
      href="#"
      (click)="navClick($event, 'consultNoteVerification')"
      [class.active]="currentSection === 'consultNoteVerification'">
      Validate Specialist Encounter Timeframe
    </a>
  }
  @if (showClientPrescriptionMatches) {
    <a
      class="nav-item nav-link"
      href="#"
      (click)="navClick($event, 'clientPrescriptionMatches')"
      [class.active]="currentSection === 'clientPrescriptionMatches'">
      E-Prescribe Matches
    </a>
  }
  <a
    class="nav-item nav-link"
    href="#"
    (click)="navClick($event, 'validatePatientCareOwnership')"
    [class.active]="currentSection === 'validatePatientCareOwnership'">
    Validate Patient Care Ownership
  </a>
  @if (showValidatePrescriptionWrittenAtCe) {
    <a
      class="nav-item nav-link"
      href="#"
      (click)="navClick($event, 'validatePrescriptionWrittenAtCe')"
      [class.active]="currentSection === 'validatePrescriptionWrittenAtCe'">
      Validate Prescription
    </a>
  }
  <a
    class="nav-item nav-link"
    href="#"
    (click)="navClick($event, 'captureVerification')"
    [class.active]="currentSection === 'captureVerification'">
    Verification
  </a>
  @if (capture.userAuditable || capture.userAuditOutcome) {
    <a
      class="nav-item nav-link"
      href="#"
      (click)="navClick($event, 'captureUserAudit')"
      [class.active]="currentSection === 'captureUserAudit'">
      Audit
    </a>
  }
</nav>
